import types from 'redux/types';
import { checkTypeValue } from 'helpers';
import {
  baseStats,
  fetchHighlightHistory,
  fetchHighlightHistoryFailed,
  fetchHighlightHistorySuccess,
  fetchMessageStats,
  fetchMessageStatsFailed,
  fetchMessageStatsSuccess,
  fetchStats,
  fetchStatsByTime,
  fetchStatsByTimeFailed,
  fetchStatsByTimeSuccess,
  fetchStatsFailed,
  fetchStatsSuccess,
} from 'redux/handleReducers';
import components, { typeUnmounted } from 'consts/components';

const initialState = {
  ...baseStats(),
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case types.REQUEST_MESSAGE_STATS:
      return fetchMessageStats(actions, state);

    case types.REQUEST_MESSAGE_STATS_SUCCESS:
      return fetchMessageStatsSuccess(actions, state);

    case types.REQUEST_MESSAGE_STATS_FAILED:
      return fetchMessageStatsFailed(actions, state);

    case types.REQUEST_GET_STATS:
      return fetchStats(actions, state);

    case types.REQUEST_GET_STATS_SUCCESS:
      return fetchStatsSuccess(actions, state);

    case types.REQUEST_GET_STATS_FAILED:
      return fetchStatsFailed(actions, state);

    case types.REQUEST_GET_HIGHLIGHT_HIST:
      return fetchHighlightHistory(actions, state);

    case types.REQUEST_GET_HIGHLIGHT_HIST_SUCCESS:
      return fetchHighlightHistorySuccess(actions, state);

    case types.REQUEST_GET_HIGHLIGHT_HIST_FAILED:
      return fetchHighlightHistoryFailed(actions, state);

    case types.REQUEST_STATS_BY_TIME:
      return fetchStatsByTime(actions, state);

    case types.REQUEST_STATS_BY_TIME_SUCCESS:
      return fetchStatsByTimeSuccess(actions, state);

    case types.REQUEST_STATS_BY_TIME_FAILED:
      return fetchStatsByTimeFailed(actions, state);

    case typeUnmounted(components.statistics):
    case typeUnmounted(components.homepage):
      return baseStats();

    default:
      return state;
  }
};
